import { render, staticRenderFns } from "./CategoriesList.vue?vue&type=template&id=3086bf05&scoped=true"
import script from "./CategoriesList.vue?vue&type=script&lang=js"
export * from "./CategoriesList.vue?vue&type=script&lang=js"
import style0 from "./CategoriesList.vue?vue&type=style&index=0&id=3086bf05&prod&lang=postcss&scoped=true"
import style1 from "./CategoriesList.vue?vue&type=style&index=1&id=3086bf05&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3086bf05",
  null
  
)

export default component.exports